const CARDS = [
  {
    title: '流浪地球3 · 人类最后的迁徙',
    desc: '太阳急速膨胀，人类面临前所未有的生存危机。吴京、刘德华领衔主演，年度最受期待的国产科幻巨制。',
    category: '科幻',
    img: 'https://readdy.ai/api/search-image?query=Massive%20space%20station%20orbiting%20above%20a%20frozen%20Earth%20with%20thousands%20of%20engines%20firing%20blue%20flames%2C%20dramatic%20cosmic%20lighting%2C%20epic%20science%20fiction%20scale%2C%20dark%20space%20background%20with%20stars%2C%20cinematic%20wide%20shot%2C%20cold%20and%20warm%20contrast%2C%20no%20text&width=800&height=500&seq=cards-01-v1&orientation=landscape',
  },
  {
    title: '封神第二部 · 战火西岐',
    desc: '姜子牙率众神迎战殷商大军，神话史诗特效再升级。费翔、黄渤、于适等原班人马回归，续写封神传奇。',
    category: '奇幻',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battlefield%20with%20warriors%20in%20ornate%20armor%20facing%20mythical%20beasts%20under%20a%20stormy%20sky%2C%20golden%20and%20crimson%20banners%20flying%2C%20dramatic%20lightning%20strikes%2C%20epic%20fantasy%20war%20scene%2C%20warm%20torch%20light%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=cards-02-v1&orientation=landscape',
  },
  {
    title: '速度与激情11 · 最终章',
    desc: '唐老大率领家族完成终极任务，横跨三大洲的速度追逐战。系列收官之作，燃爆你的肾上腺素。',
    category: '动作',
    img: 'https://readdy.ai/api/search-image?query=High%20speed%20sports%20cars%20racing%20through%20a%20neon-lit%20city%20at%20night%2C%20motion%20blur%20and%20light%20trails%2C%20wet%20asphalt%20reflecting%20colorful%20city%20lights%2C%20intense%20action%20atmosphere%2C%20cinematic%20dynamic%20shot%2C%20warm%20and%20cool%20contrast%2C%20no%20text&width=800&height=500&seq=cards-03-v1&orientation=landscape',
  },
  {
    title: '熊出没·重启未来',
    desc: '光头强和熊大熊二穿越到未来世界，开启全新冒险旅程。国产动画票房冠军系列最新力作。',
    category: '动画',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20animated%20forest%20landscape%20with%20futuristic%20elements%20blending%20nature%20and%20technology%2C%20warm%20sunlight%20through%20trees%2C%20playful%20colorful%20atmosphere%2C%20family-friendly%20animation%20style%2C%20lush%20greenery%20with%20glowing%20digital%20accents%2C%20wide%20scenic%20shot%2C%20no%20text&width=800&height=500&seq=cards-04-v1&orientation=landscape',
  },
  {
    title: '奥本海默 · 原子弹之父',
    desc: '克里斯托弗·诺兰执导，基里安·墨菲主演。讲述"原子弹之父"罗伯特·奥本海默的传奇一生与内心挣扎。',
    category: '传记',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20contrast%20scene%20with%20brilliant%20orange%20mushroom%20cloud%20in%20distance%2C%20silhouette%20of%20a%20man%20in%20vintage%20suit%20and%20hat%2C%20desert%20landscape%2C%20intense%20and%20contemplative%20mood%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic%2C%20no%20text&width=800&height=500&seq=cards-05-v1&orientation=landscape',
  },
  {
    title: '热辣滚烫 · 为梦想拼搏',
    desc: '贾玲导演并主演的励志喜剧大片，讲述平凡女孩通过拳击找回自我的热血故事，年度口碑话题之作。',
    category: '喜剧',
    img: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20boxing%20gym%20interior%20with%20punching%20bags%20and%20ropes%2C%20golden%20hour%20light%20streaming%20through%20windows%2C%20inspiring%20and%20uplifting%20atmosphere%2C%20dust%20particles%20floating%20in%20light%20beams%2C%20warm%20amber%20tones%2C%20motivational%20sports%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=cards-06-v1&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            编辑团队为你精选的必看好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    target.parentElement!.classList.add('hidden');
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-800 text-xs font-medium">
                  {card.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}